import { render, staticRenderFns } from "./LocalTextItem.vue?vue&type=template&id=09d0115c&scoped=true"
import script from "./LocalTextItem.vue?vue&type=script&lang=js"
export * from "./LocalTextItem.vue?vue&type=script&lang=js"
import style0 from "./LocalTextItem.vue?vue&type=style&index=0&id=09d0115c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d0115c",
  null
  
)

export default component.exports